webpackJsonp([183864195045431],{

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _particles = __webpack_require__(57);
	
	var _particles2 = _interopRequireDefault(_particles);
	
	var _container = __webpack_require__(8);
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HeroSmall = function HeroSmall(_ref) {
	  var title = _ref.title,
	      desc = _ref.desc,
	      name = _ref.name;
	  return _react2.default.createElement(
	    'div',
	    { className: 'hero-area-small' },
	    _react2.default.createElement(_particles2.default, null),
	    _react2.default.createElement(
	      _container2.default,
	      { customClassName: 'hero-area-container' },
	      _react2.default.createElement(
	        'p',
	        { className: 'static-project-name' },
	        name
	      ),
	      _react2.default.createElement(
	        'h1',
	        null,
	        title
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        desc
	      )
	    )
	  );
	};
	
	exports.default = HeroSmall;
	module.exports = exports['default'];

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _container = __webpack_require__(8);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _heroSmallProject = __webpack_require__(77);
	
	var _heroSmallProject2 = _interopRequireDefault(_heroSmallProject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Coinis = function Coinis(props) {
	  return _react2.default.createElement(
	    "main",
	    null,
	    _react2.default.createElement(_heroSmallProject2.default, {
	      name: "abago.com",
	      title: "Flight Search / Online Travel Agency",
	      desc: "Book cheap flight tickets"
	    }),
	    _react2.default.createElement(
	      _container2.default,
	      { customClassName: "project-padding" },
	      _react2.default.createElement("img", { src: "/static/abago-logo.svg", className: "project-logo", alt: "Abago.com" }),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Based in Montenegro, Abago is primarily an IT company, fully dedicated to unlocking the potential of travel innovations and simplifying the process of online booking. "
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We are a creative customer oriented team who is constantly working on seeking innovative solutions regarding traveling and simplifying the process of booking flights by providing personalized solutions at competent prices."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "As a group of young enthusiasts we are dedicated to making a customer\u2019s experience as enjoyable as possible and provide flights and accommodations all over the world. Our platform allows users to choose over 5,000 flights daily and more than 450 airlines and the needs of the customers are placed at the core of our business."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Our vision us to strengthen our position within the online travel market by providing quality, creative, competitive and technology responsible services in the sector, and to make it a preferable flight booking address for nomads, birds of passage, business or leisure travelers, and the like."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Among all of this, customers will be able to choose their desired destination with our intelligent suggestive tech that can select places on the map based on weather, overnight flight preferences, intention, mood, etc."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Abago is an excellent solution for a personal travel manager because we provide reliable and secure services. "
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "More at: ",
	        _react2.default.createElement(
	          "a",
	          { href: "https://abago.com", target: "_blank" },
	          "abago.com"
	        )
	      )
	    )
	  );
	};
	
	exports.default = Coinis;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-project-abago-js-8553d340d7947822e143.js